import { DecimalPipe, PercentPipe } from "@angular/common";
import { OnDestroy, Pipe, PipeTransform } from "@angular/core";
import { select, Store } from "@ngrx/store";
import * as moment from "moment";
import { Subscription, Observable, BehaviorSubject } from "rxjs";
import { loadedTenantState } from "src/app/store/reducers";

@Pipe({
  name: "formatPipe",
})
export class FormatPipe implements PipeTransform, OnDestroy {
  tenantSub: Subscription;
  tenant$: Observable<any>;
  formatter: any;

  locale: string = localStorage.getItem("locale");

  constructor(private store: Store, private decimalPipe: DecimalPipe) {
    this.tenant$ = this.store.pipe(select(loadedTenantState));
  }

  transform(value: any, params?: any) {
    let formattedSubject = new BehaviorSubject<string>("");
    this.tenantSub = this.tenant$.subscribe((data: any) => {
      this.formatter = this.format(value, data, params);
      formattedSubject.next(this.formatter);
    });
    return formattedSubject;
  }

  format(value: any, formatter: any, formatType: any): any {
    if (!formatter) {
      return value;
    }

    let result: string = "";

    switch (formatType) {
      case "amountFormat":
        result = this.decimalPipe.transform(
          value,
          formatter?.amountFormat,
          this.locale
        );
        break;
      case "currencyFormat": {
        const pattern = formatter?.currencyFormat || "1.2-2";
        const symbol = formatter?.currency.symbol || ""; 

        const numeric =
          this.decimalPipe.transform(value, pattern, this.locale) ?? "";

        if (!symbol) {
          result = numeric;
        } else {
          result = `${numeric + symbol} ${symbol}`
             
        }

        result = result.replace(',', '.');

        break;
      }
      case "dateFormat":
        result = moment(value).format(`${formatter?.dateFormat}`).toString();
        break;
      case "timeFormat":
        result = moment(value).format(`${formatter?.timeFormat}`).toString();
        break;
      case "datetimeFormat":
        result = moment(value)
          .format(`${formatter?.datetimeFormat}`)
          .toString();
        break;
      case "unitPriceFormat":
        result = this.decimalPipe.transform(
          value,
          formatter?.unitPriceFormat,
          this.locale
        );
        result = result.toString().replace(",", ".");
        break;
      case "fuelUnitPriceFormat":
        result = this.decimalPipe.transform(
          value,
          formatter?.fuelUnitPriceFormat
        );
        break;
      case "percentageFormat":
        result = this.decimalPipe.transform(value, formatter?.unitPriceFormat);
        result = result.toString().replace(",", ".");
        break;
      default:
        result = value;
        break;
    }

    return result;
  }

  ngOnDestroy(): void {
    if (this.tenantSub) {
      this.tenantSub.unsubscribe();
    }
  }
}
